export default __webpack_public_path__ + "static/media/FORUM NAUCALPAN TORRE 2.71362c63.pdf";